import {
    AppstoreOutlined,
    ContactsOutlined,
    DollarOutlined,
    FileTextOutlined,
    LayoutOutlined,
    NotificationOutlined,
    PictureOutlined,
    UsergroupAddOutlined,
    UserSwitchOutlined
} from '@ant-design/icons'

import Pieces from '../pages/pieces/Pieces'
import Info from '../pages/account/Info'
import NewPieces from '../pages/pieces/NewPieces'
// import NewPiecesStepper from "../pages/NewPiecesStepper";
import ShowcaseBio from '../pages/showcase/ShowcaseBio'
import ShowcaseMedia from '../pages/showcase/ShowcaseMedia'
import Order from '../pages/income/Order'
import Payment from '../pages/income/Payment'
import AgreementNew from '../pages/document/AgreementNew'
import NewAgreement from '../pages/document/NewAgreement'
import SignAgreement from '../pages/document/SignAgreement'
import Contract from '../pages/income/Contract'
import Notification from '../pages/admin/Notification'
import Collections from '../pages/collection/Collections'
import NewCollection from '../pages/collection/NewCollection'
import FAQ from '../pages/FAQ'
import FAQFrame from '../pages/FAQFrame'
import Exhibition from '../pages/exhibition/Exhibition'
import AddNewExhibition from '../pages/exhibition/AddNewExhibition'
import Apply from '../pages/apply/Apply'
import BulkUploadImage from '../pages/pieces/BulkUploadImage'
import ImportArtworkSheets from '../pages/pieces/ImportArtworkSheets'
import PartnerContact from '../pages/contact/Contact'
import AddPartnerProfile from '../pages/contact/NewPartnerProfile'
import NewContact from '../pages/contact/NewContact'
import ExhibitionAdmin from '../pages/admin/ExhibitionAdmin'
import NewExhibition from '../pages/admin/NewExhibitionAdmin'
import CancelAccount from '../component/account/CancelAccount'
import Profile from '../pages/account/Profile'
import Billing from '../pages/Billing'

import {
    URL_ACCOUNT_INFO,
    URL_ADMIN_EDIT_USER_ID,
    URL_ADMIN_NEW_EXHIBITIONS,
    URL_AGREEMENTS,
    URL_APPLY_REVART,
    URL_BILLING,
    URL_BULK_UPLOAD,
    URL_BULK_UPLOAD_UPDATE,
    URL_CANCEL_ACCOUNT,
    URL_COLLECTIONS,
    URL_CONTACTS,
    URL_DASHBOARD,
    URL_EDIT_AGREEMENTS_ID,
    URL_EDIT_COLLECTIONS_ID,
    URL_EDIT_CONTACT,
    URL_EDIT_CONTACT_GROUP,
    URL_EDIT_EXHIBITIONS_ID,
    URL_EDIT_ORDERS,
    URL_EDIT_PIECES_ID,
    URL_EXHIBITIONS,
    URL_EXHIBITIONS_ADMIN,
    URL_FAQS,
    URL_FAQS_ID,
    URL_IMPORT_CSV,
    URL_INCOME_ORDER,
    URL_INCOME_PAYMENT,
    URL_INCOME_REPORT,
    URL_NEW_AGREEMENTS,
    URL_NEW_COLLECTIONS,
    URL_NEW_CONTACT,
    URL_NEW_CONTACT_GROUP,
    URL_NEW_EXHIBITIONS,
    URL_NEW_NOTIFICATION_ADMIN,
    URL_NEW_ORDERS,
    URL_NEW_PAYMENT,
    URL_NEW_PIECES,
    URL_NEW_PIECES_STEPPER,
    URL_NOTIFICATION_ADMIN,
    URL_ORDER_DETAILS,
    URL_PIECES,
    URL_PROFILE_INFO,
    URL_SHOWCASE_ARTWORK,
    URL_SHOWCASE_BIO,
    URL_SHOWCASE_PUBLISH,
    URL_SHOWCASE_SPOTLIGHTS,
    URL_SIGN_AGREEMENTS, URL_STATEMENTS, URL_STATEMENTS_ID, URL_SUBSCRIPTION,
    URL_SUBSCRIPTION_CANCEL,
    URL_SUBSCRIPTION_FAILED,
    URL_SUBSCRIPTION_SUCCESS, URL_TEMPLATES, URL_TEMPLATES_ID,
    URL_USERS_ADMIN, URL_WRITER_STATEMENT
} from '../const'
import NewBulkUpload from '../pages/pieces/NewBulkUpload'
import ShowcasePublish from '../pages/showcase/ShowcasePublish'
import ShowcaseArtByCollection from '../pages/showcase/ShowcaseArtByCollection'
import NewPiecesStepper from '../pages/pieces/NewPiecesStepper'
import NewOrders from '../pages/income/NewOrders'
import OrderDetails from '../pages/income/OrderDetails'
import Dashboard from '../pages/dashboard/Dashboard'
import SaleReport from '../pages/income/SaleReport'
import UserListAdmin from "../pages/admin/UserListAdmin";
import NewPayment from "../pages/income/NewPayment";
import NewNotificationAdmin from "../pages/admin/NewNotificationAdmin";
import UserEditAdmin from "../pages/admin/UserEditAdmin";
import Template from "../pages/document/Template";
import TemplateDetail from "../pages/document/TemplateDetail";
import NewStatementStepper from "../pages/writer/NewStatementStepper";
import Statement from "../pages/document/Statement";

const UserRoleLists = ['user', 'artist', 'admin', 'gallery']
const ArtistRoleLists = ['user', 'artist', 'admin', 'gallery']
const AdminOnlyLists = ['admin']

export const routes = [
    // dashboard
    {
        path: '/sam/',
        exact: true,
        main: () => <Dashboard/>,
        breadcrumbName: 'dashboard',
        role: UserRoleLists
    },
    {
        path: URL_DASHBOARD,
        exact: true,
        main: () => <Dashboard/>,
        breadcrumbName: 'dashboard',
        role: UserRoleLists
    },
    // artwork
    {
        path: URL_PIECES,
        exact: true,
        main: () => <Pieces/>,
        breadcrumbName: 'pieces',
        role: UserRoleLists
    },
    {
        path: URL_NEW_PIECES,
        role: UserRoleLists,
        breadcrumbName: 'new piece',
        main: () => <NewPiecesStepper new={true}/>
    },
    {
        path: URL_NEW_PIECES_STEPPER,
        role: UserRoleLists,
        breadcrumbName: 'new piece',
        main: () => <NewPiecesStepper new={true}/>
    },
    {
        path: URL_EDIT_PIECES_ID,
        role: UserRoleLists,
        breadcrumbName: 'new piece',
        main: () => <NewPieces new={false}/>
    },
    {
        path: URL_NEW_COLLECTIONS,
        main: () => <NewCollection new={true}/>,
        breadcrumbName: 'new collection',
        role: UserRoleLists
    },
    {
        path: URL_EDIT_COLLECTIONS_ID,
        main: () => <NewCollection new={false}/>,
        breadcrumbName: 'edit collection',
        role: UserRoleLists
    },
    {
        path: URL_BULK_UPLOAD_UPDATE,
        role: UserRoleLists,
        main: () => <NewBulkUpload new={true}/>
    },
    {
        path: URL_BULK_UPLOAD,
        main: () => <BulkUploadImage/>,
        breadcrumbName: 'bulk upload',
        role: UserRoleLists
    },
    {
        path: URL_IMPORT_CSV,
        main: () => <ImportArtworkSheets/>,
        breadcrumbName: 'import csv',
        role: UserRoleLists
    },
    // documents
    {
        path: URL_EDIT_AGREEMENTS_ID,
        main: () => <Contract/>,
        breadcrumbName: 'contract',
        role: UserRoleLists
    },
    // income
    {
        path: URL_NEW_ORDERS,
        main: () => <NewOrders isNew={true}/>,
        breadcrumbName: 'new order',
        role: AdminOnlyLists
    },
    {
        path: URL_NEW_PAYMENT,
        main: () => <NewPayment/>,
        exact: true,
        breadcrumbName: 'new payment',
        role: AdminOnlyLists
    },
    {
        path: URL_NEW_AGREEMENTS,
        role: UserRoleLists,
        breadcrumbName: 'new agreement',
        main: () => <NewAgreement new={true}/>
    },
    {
        path: URL_SIGN_AGREEMENTS,
        role: UserRoleLists,
        breadcrumbName: 'sign agreement',
        exact: true,
        main: () => <SignAgreement/>
    },
    {
        path: URL_TEMPLATES_ID,
        role: UserRoleLists,
        breadcrumbName: 'template detail',
        exact: true,
        main: () => <TemplateDetail/>
    },
     {
        path: URL_STATEMENTS_ID,
        role: UserRoleLists,
        breadcrumbName: 'statement',
        exact: true,
        main: () => <NewStatementStepper/>
    },
    {
        path: URL_EDIT_ORDERS,
        main: () => <NewOrders isNew={false}/>,
        breadcrumbName: 'edit order',
        role: UserRoleLists
    },
    {
        path: URL_ORDER_DETAILS,
        main: () => <OrderDetails/>,
        breadcrumbName: 'details',
        role: UserRoleLists
    },
    // others
    {
        path: URL_FAQS_ID,
        main: () => <FAQFrame/>,
        breadcrumbName: 'faq',
        role: UserRoleLists
    },
    // contacts
    {
        path: URL_NEW_CONTACT_GROUP,
        main: () => <AddPartnerProfile new={true}/>,
        role: UserRoleLists
    },
    {
        path: URL_EDIT_CONTACT_GROUP,
        main: () => <AddPartnerProfile new={false}/>,
        role: UserRoleLists
    },
    {
        path: URL_NEW_CONTACT,
        exact: true,
        main: () => <NewContact new={true}/>,
        breadcrumbName: 'new contact',
        role: UserRoleLists
    },
    {
        path: URL_EDIT_CONTACT,
        exact: true,
        main: () => <NewContact new={false}/>,
        breadcrumbName: 'edit contact',
        role: UserRoleLists
    },
    // exhibitions
    {
        path: URL_ADMIN_NEW_EXHIBITIONS,
        exact: true,
        main: () => <NewExhibition new={true}/>,
        breadcrumbName: 'new exhibition',
        role: UserRoleLists
    },
    {
        path: URL_ADMIN_EDIT_USER_ID,
        main: () => <UserEditAdmin/>,
        breadcrumbName: 'edit user',
        role: UserRoleLists
    },
    {
        path: URL_EDIT_CONTACT,
        exact: true,
        main: () => <NewContact new={false}/>,
        breadcrumbName: 'edit contact',
        role: UserRoleLists
    },
    {
        path: URL_NEW_EXHIBITIONS,
        main: () => <AddNewExhibition new={true}/>,
        breadcrumbName: 'new exhibition',
        role: UserRoleLists
    },
    {
        path: URL_EDIT_EXHIBITIONS_ID,
        main: () => <AddNewExhibition new={false}/>,
        breadcrumbName: 'edit exhibition',
        role: UserRoleLists
    },
    {
        path: URL_ACCOUNT_INFO,
        main: () => <Info/>,
        breadcrumbName: 'My Account',
        role: UserRoleLists
    },
    {
        path: URL_PROFILE_INFO,
        main: () => <Profile/>,
        breadcrumbName: 'My Profile',
        role: UserRoleLists
    },
    {
        path: URL_FAQS,
        main: () => <FAQ/>,
        exact: true,
        breadcrumbName: 'FAQ',
        role: UserRoleLists
    },
    {
        path: URL_APPLY_REVART,
        main: () => <Apply/>,
        exact: true,
        breadcrumbName: 'Apply RevArt',
        role: UserRoleLists
    },
    {
        path: URL_CANCEL_ACCOUNT,
        exact: true,
        breadcrumbName: 'Cancel',
        role: UserRoleLists,
        main: () => <CancelAccount/>
    },
    {
        path: URL_NEW_NOTIFICATION_ADMIN,
        exact: true,
        main: () => <NewNotificationAdmin new={true}/>,
        breadcrumbName: 'new notification',
        role: AdminOnlyLists
    },
    //Billing
    {
        path: URL_BILLING,
        exact: true,
        main: () => <Billing/>,
        breadcrumbName: 'Billing',
        role: UserRoleLists
    },
    {
        path: URL_SUBSCRIPTION,
        exact: true,
        main: () => <Billing/>,
        breadcrumbName: 'Billing',
        role: UserRoleLists
    },
    //Subscription ( These need to be handled by redirects to billing or some other method )
    {
        path: URL_SUBSCRIPTION_SUCCESS,
        exact: true,
        main: () => <Billing/>,
        breadcrumbName: 'Billing',
        role: UserRoleLists
    },
    {
        path: URL_SUBSCRIPTION_CANCEL,
        exact: true,
        main: () => <Billing/>,
        breadcrumbName: 'Billing',
        role: UserRoleLists
    },
    {
        path: URL_SUBSCRIPTION_FAILED,
        exact: true,
        main: () => <Billing/>,
        breadcrumbName: 'Billing',
        role: UserRoleLists
    },
     {
        path: URL_WRITER_STATEMENT,
        exact: true,
        main: () => <NewStatementStepper new={true}/>,
        breadcrumbName: 'Statement',
        role: UserRoleLists
    }
]

export const siders = [
    {
        title: 'Dashboard',
        key: URL_DASHBOARD,
        icon: <AppstoreOutlined style={{fontSize: '24px', paddingRight: '4px'}}/>,
        role: UserRoleLists,
        exact: true,
        main: () => <Dashboard/>
    },
    {
        title: 'Artwork',
        icon: <PictureOutlined style={{fontSize: '20px', paddingRight: '6px'}}/>,
        role: UserRoleLists,
        key: 'pieces',
        data_tut: 'reactour__pieces_parent',
        subMenu: [
            {
                title: 'Pieces',
                data_tut: 'reactour__pieces',
                key: URL_PIECES,
                role: UserRoleLists,
                exact: true,
                main: () => <Pieces/>
            },
            {
                data_tut: 'reactour__collections',
                title: 'Collections',
                key: URL_COLLECTIONS,
                role: UserRoleLists,
                exact: true,
                main: () => <Collections/>
            },
            {
                data_tut: 'reactour__exhibitions',
                title: 'Exhibitions',
                key: URL_EXHIBITIONS,
                role: UserRoleLists,
                exact: true,
                main: () => <Exhibition/>
            },
            /*{
                    title: "BulkAction",
                    key: "bulkAction",
                    role: ["artist"],
                  },*/
        ]
    },
    {
        title: 'Showcase',
        key: 'showcase',
        data_tut: 'reactour__showcase_parent',
        icon: <LayoutOutlined style={{fontSize: '20px', paddingRight: '6px'}}/>,
        role: UserRoleLists,
        subMenu: [
            {
                title: '(1) Basic Info',
                key: URL_SHOWCASE_BIO,
                role: UserRoleLists,
                main: () => <ShowcaseBio/>
            },
            {
                title: '(2) News',
                key: URL_SHOWCASE_SPOTLIGHTS,
                role: UserRoleLists,
                main: () => <ShowcaseMedia/>
            },
            {
                title: '(3) Artworks',
                key: URL_SHOWCASE_ARTWORK,
                role: UserRoleLists,
                main: () => <ShowcaseArtByCollection/>
            },
            {
                title: '(4) Publish',
                key: URL_SHOWCASE_PUBLISH,
                role: UserRoleLists,
                main: () => <ShowcasePublish/>
            }
        ]
    },
    {
        title: 'Income',
        key: 'income',
        data_tut: 'reactour__income_parent',
        icon: <DollarOutlined style={{fontSize: '20px', paddingRight: '6px'}}/>,
        role: UserRoleLists,
        subMenu: [
            {
                title: 'Order',
                key: URL_INCOME_ORDER,
                role: ArtistRoleLists,
                exact: true,
                main: () => <Order/>
            },
            {
                title: 'Payment',
                key: URL_INCOME_PAYMENT,
                role: ArtistRoleLists,
                exact: true,
                main: () => <Payment/>
            },
            // {
            //     title: 'Sales Report',
            //     key: URL_INCOME_REPORT,
            //     role: ArtistRoleLists,
            //     main: () => <SaleReport/>
            // }
        ]
    },
    {
        title: 'Documents',
        key: 'documents',
        data_tut: 'reactour__document_parent',
        icon: <FileTextOutlined style={{fontSize: '20px', paddingRight: '6px'}}/>,
        role: UserRoleLists,
        subMenu: [
            {
                title: 'Agreements',
                key: URL_AGREEMENTS,
                exact: true,
                role: UserRoleLists,
                main: () => <AgreementNew/>
            },
            {
                title: 'Templates',
                key: URL_TEMPLATES,
                exact: true,
                role: UserRoleLists,
                main: () => <Template/>
            },
            {
                title: 'Statements',
                key: URL_STATEMENTS,
                exact: true,
                role: UserRoleLists,
                main: () => <Statement/>
            }
        ]
    },
    {
        title: 'Contacts',
        key: URL_CONTACTS,
        data_tut: 'reactour__contact_parent',
        exact: true,
        icon: <ContactsOutlined style={{fontSize: '20px', paddingRight: '6px'}}/>,
        role: UserRoleLists,
        main: () => <PartnerContact/>
    },
    {
        title: 'Admin',
        key: 'admin',
        data_tut: 'reactour__admin_parent',
        icon: <UserSwitchOutlined style={{fontSize: '20px', paddingRight: '6px'}}/>,
        role: AdminOnlyLists,
        exact: true,
        subMenu: [
            {
                title: 'Exhibition',
                key: URL_EXHIBITIONS_ADMIN,
                exact: true,
                role: AdminOnlyLists,
                main: () => <ExhibitionAdmin new={true}/>
            },
            {
                title: 'Notification',
                key: URL_NOTIFICATION_ADMIN,
                exact: true,
                icon: <NotificationOutlined style={{fontSize: '18px', paddingRight: '9px'}}/>,
                role: AdminOnlyLists,
                main: () => <Notification/>
            },
            {
                title: 'User',
                key: URL_USERS_ADMIN,
                exact: true,
                icon: <UsergroupAddOutlined style={{fontSize: '18px', paddingRight: '9px'}}/>,
                role: AdminOnlyLists,
                main: () => <UserListAdmin/>
            }
        ]
    }
]
